import { useMutation, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "@/lib/queryClient";
import { resetFullEval } from "@/api/endpoints/maturity";

export function useResetMaturityFull(sessionId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => resetFullEval(sessionId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.maturity.evaluation(sessionId),
      });
    },
  });
}
